import { render, staticRenderFns } from "./cDocumentsWithPartsNew.vue?vue&type=template&id=3f887f80&scoped=true"
import script from "./cDocumentsWithPartsNew.vue?vue&type=script&lang=js"
export * from "./cDocumentsWithPartsNew.vue?vue&type=script&lang=js"
import style0 from "./cDocumentsWithPartsNew.vue?vue&type=style&index=0&id=3f887f80&prod&lang=scss&scoped=true"
import style1 from "./cDocumentsWithPartsNew.vue?vue&type=style&index=1&id=3f887f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f887f80",
  null
  
)

export default component.exports